import { createReducer, on } from '@ngrx/store';
import { setFlagReminderMsg, clearFlagReminderMsg } from './flagReminderMsg.actions';
import { initialMsgState } from './flagReminderMsg.state';

export const flagReminderMsgReducer = createReducer(
  initialMsgState,
  on(setFlagReminderMsg, (state, { msg }) => ({ ...state, flagReminderMsg : msg })),
  on(clearFlagReminderMsg, state => ({ ...state, flagReminderMsg : null }))
);
